import { Editor } from "@tinymce/tinymce-react"
import { useEffect, useRef, useState } from "react"

export default function EmailSignatureEditor({
  editorRef,
  setEditorReady,
  disabled = false,
  onEditorChange = () => {},
}) {
  return (
    <Editor
      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
      disabled={disabled}
      onInit={(_evt, editor) => {
        editorRef.current = editor
      }}
      onEditorChange={onEditorChange}
      init={{
        height: 220,
        menubar: false,
        statusbar: false,
        branding: false,
        plugins: "lists",
        toolbar: [
          "undo redo | bold italic | alignleft aligncenter alignright",
          "bullist numlist",
        ],
        paste_data_images: false,
        setup: (editor) => {
          editor.on("init", () => setEditorReady(true))
        },
      }}
    />
  )
}

export function useEmailSignatureEditorState(isActive = true) {
  const [editorReady, setEditorReady] = useState(false)
  const editorRef = useRef()

  function updateEditorContents(htmlContents) {
    if (editorReady && editorRef.current) {
      editorRef.current.setContent(htmlContents || "")
    }
  }

  function getEditorHtml() {
    if (!editorRef.current) {
      return ""
    }
    return editorRef.current.getContent()
  }

  function insertImageIntoEditor(imageDataUrl) {
    if (!editorRef.current) {
      return
    }
    editorRef.current.insertContent(
      `<p><img src="${imageDataUrl}" alt="Email signature" style="max-width: 300px;" /></p>`
    )
  }

  function signatureHtmlHasContent(html) {
    const stripped = (html || "")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim()
    return stripped.length > 0 || /<img\b/i.test(html || "")
  }

  useEffect(() => {
    if (!isActive) {
      setEditorReady(false)
    }
  }, [isActive])

  return {
    editorReady,
    setEditorReady,
    editorRef,
    updateEditorContents,
    getEditorHtml,
    insertImageIntoEditor,
    signatureHtmlHasContent,
  }
}
